import { createContext, useContext } from 'react'

type AppThemeContextProps = {
  isDarkMode: boolean
  toggleThemeMode: () => void
}

export const AppThemeContext = createContext<AppThemeContextProps>({
  isDarkMode: true,
  toggleThemeMode: () => {}
})
export const useAppThemeContext = () =>
  useContext<AppThemeContextProps>(AppThemeContext)
